<template>
  <div class="flex items-center">
    <svg
      fill="currentColor"
      :width="size"
      :height="size"
      v-for="(item, index) in ratingList"
      :class="getColor(item)"
      :key="index"
    >
      <use :xlink:href="item" class="ml-1"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Rating',
  props: {
    size: {
      default: 24
    },
    value: {
      default: 0
    }
  },
  computed: {
    ratingList() {
      return [...Array(5).keys()].map((item) => {
        return item + 1 <= Math.round(+this.value)
          ? '/img/sprite.svg#ic_review-solid'
          : '/img/sprite.svg#ic_review-empty'
      })
    }
  },
  methods: {
    getColor(item) {
      return item === '/img/sprite.svg#ic_review-solid' ? 'text-orange' : 'text-black-light-2'
    }
  }
}
</script>
